import React, { useState } from "react";
import { CardBody, Input } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import styles from "../../styles.scss";
import SectionLabel from "../../common/sectionLabel";
import { LeftSidebarVariablesProp } from "../../common/types/variables";

const NewsfeedFooterSection = ({ variables }: LeftSidebarVariablesProp) => {
  const [firstPart, setFirstPart] = variables["firstPart"];
  const [secondPart, setSecondPart] = variables["secondPart"];
  const [version, setVersion] = variables["version"];

  return (
    <CardBody>
      <div className={styles.section}>
        <SectionLabel
          label="First part"
          tooltip="Add the copyright notice and any other important info in your footer. Whenever you need to add the current year, just add YEAR and it will update automatically."
        />
        <Input
          type="text"
          value={firstPart}
          onChange={e => setFirstPart(e.target.value.replace('YEAR', new Date().getFullYear().toString()))}
          className={styles.input}
        />
{/*         <SectionLabel
          label="Version"
          tooltip="Add the version of your charity. Whenever you need to add the current year, just add YEAR and it will update automatically."
        />
        <Input
          type="text"
          value={version}
          onChange={e => setVersion(e.target.value.replace('YEAR', new Date().getFullYear().toString()))}
          className={styles.input}
        /> */}
        <SectionLabel
          label="Second part"
          tooltip="Add the remaining info in your footer. Whenever you need to add the current year, just add YEAR and it will update automatically."
        />
        <Input
          type="text"
          value={secondPart}
          onChange={e => setSecondPart(e.target.value.replace('YEAR', new Date().getFullYear().toString()))}
          className={styles.input}
        />
      </div>
    </CardBody>
  );
};

export default withStyles(styles)(NewsfeedFooterSection);
